<form class="field" [formGroup]="form" [ngClass]="{'active':isActive}">
    <button class="field-action">
        <div class="field-action-media">
            <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
        </div>
    </button>
    <input autocomplete="off" class="field-input" (focus)="setActive()"
           formControlName="query" id="input" placeholder="Global menu search" type="text">
    <div class="modal" [@fade] *ngIf="isSearching()">
        <div class="modal-message" *ngIf="!results.length">
            <fui-empty [description]="'fui.$navigation.message.noResultsDescription'"
                       id="empty" [title]="'fui.$navigation.message.noResultsTitle'">
                <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
            </fui-empty>
        </div>
        <div class="modal-main" *ngIf="results.length">
            <div class="results">
                <button class="result" id="result-{{index}}" *ngFor="let result of results; let index = index"
                        [routerLink]="result.href"
                        [ngClass]="{'disabled':result.availability === null || (result.availability | async) === FUINavigationLinkAvailability.DISABLED}">
                    <div class="result-breadcrumbs">
                        <div class="result-breadcrumbs-breadcrumb" id="breadcrumb-{{depth}}"
                             *ngFor="let breadcrumb of result.breadcrumbs; let depth = index">
                            {{breadcrumb | translate}}
                        </div>
                    </div>
                    <div class="result-label">
                        <div class="result-label-title" id="title">
                            {{result.title | translate}}
                        </div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</form>
